/* eslint-disable @typescript-eslint/no-explicit-any */
import { ResponseType } from '@/types/response-api'
import { AxiosResponse } from 'axios'
import { toast } from 'sonner'
import API, { API_BLOG } from './axios.config'

//MARK: BLOG
export const BlogService = {
  fetchNews: async (locale: string): Promise<AxiosResponse | null> => {
    try {
      const res: ResponseType = await API.get('/api/v1/user/article/list-article-user', {
        params: { keyword: locale }
      })
      if (!res.error) {
        return res.data
      } else {
        toast.error(res.data.message)
        return null
      }
    } catch (error: any) {
      console.log(error, 'errorerror')
      const message = error?.response?.data?.message || error?.message
      toast.error(message)
      return error.response
    }
  },

  fetchNewsForBlogPost: async (locale: string): Promise<AxiosResponse> => {
    return await API_BLOG.get('/api/v1/user/article/list-article-user', {
      params: { keyword: locale }
    })
  },

  fetchDetailPost: async (slug: string, locale: string): Promise<AxiosResponse> => {
    return await API_BLOG.get('/api/v1/user/article/detail-article-user', {
      params: { slug: slug, language_code: locale }
    })
  },

  //MARK: CONTACT - Create a new contact (POST)
  createContact: async (data: {
    name: string
    email: string
    subject: string
    content: string
  }): Promise<AxiosResponse | null> => {
    try {
      const res: any = await API.post('/api/v1/user/contact/create-contact', data)
      if (!res.error) {
        toast.success('Contact created successfully!')
        return res.data
      } else {
        toast.error(res.data.message)
        return null
      }
    } catch (error: any) {
      const message = error.response.data?.message || error.message
      toast.error(message)
      return error.response
    }
  }
}
